<template>
  <!-- Header Link -->
  <li class="nav-item m-0 py-0 w-100">
    <a :class="linkClass" tabindex="0">
      <IneaIcone
        v-if="iconName.length"
        :name="iconName"
        class="me-1_2"
        :comment="comment"
        size="xxs"
        aria-expanded="false"
      />
      {{ text }}
    </a>
  </li>
</template>

<script>
import IneaIcone from "@clir/IneaIcone/IneaIcone";
export default {
  name: "ApplicationHeaderLink",
  props: {
    buttonConfig: { type: Object, default: () => {} }
  },
  computed: {
    linkClass() {
      return this.prefixStringKey(this.buttonConfig, "buttonColor", {
        prefix: "nav-link py-2 nav-link-",
        defaut :"nav-link py-2"
      });
    },
    text() {
      return this.getKey(this.buttonConfig, "text", "");
    },
    comment() {
      return this.getKey(this.buttonConfig, "comment", this.text);
    },
    iconName() {
      return this.getKey(this.buttonConfig, "iconName", "");
    }
  },
  components: {
    IneaIcone
  }
};
</script>